import { render, staticRenderFns } from "./DecoderInfo.vue?vue&type=template&id=68c884cd"
import script from "./DecoderInfo.vue?vue&type=script&lang=js"
export * from "./DecoderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports